import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 切換分頁時將頁面捲動至最上方。
 * 主內容在 .main-content 內捲動，登入頁等則捲動 window。
 */
const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const mainContent = document.querySelector('.main-content');
        if (mainContent) {
            mainContent.scrollTo(0, 0);
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
